import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function resetPasswordFormReducer(state = initialState.resetPasswordForm, action) {
    switch (action.type) {
        case types.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                isResetPasswordSuccessful: true,
                resetPasswordMessages: action.resetPasswordMessages
            };
        case types.RESET_PASSWORD_ERROR:
            return {
                ...state,
                isResetPasswordSuccessful: false,
                resetPasswordMessages: action.resetPasswordMessages
            };
        case types.LOAD_RESET_PASSWORD_FORM_SUCCESS:
            return {
                ...state,
                isFormLoadSuccessful: true,
                resetPasswordFormData: action.resetPasswordFormData,
                resetPasswordMessages: []
            };
        case types.LOAD_RESET_PASSWORD_FORM_ERROR:
            return {
                ...state,
                isFormLoadSuccessful: false,
                resetPasswordFormData: {},
                resetPasswordMessages: []
            };
        case types.RESET_RESET_PASSWORD_FORM_STATE:
            return initialState.resetPasswordForm;
        default:
            return state;
    }
}
